export const SORTING_OPTIONS = [
  {
    label: 'Performance',
    value: 'value'
  },
  {
    label: 'Holding Name',
    value: 'name'
  },
  {
    label: '$ Invested',
    value: 'investment'
  },
  {
    label: 'PnL',
    value: 'periodPnl'
  }
];

export const BARCHART_SORTING_OPTIONS = [
  {
    label: 'Performance',
    value: 'value'
  },

  {
    label: '$ Invested',
    value: 'investment'
  },
  {
    label: 'PnL',
    value: 'periodPnl'
  }
];

export const GROUP_OPTIONS = [
  {
    label: 'Company',
    value: 'Company'
  },
  {
    label: 'Holding',
    value: 'Holding'
  },
  {
    label: 'Share Class',
    value: 'Share Class'
  }
];

export const RADIO_OPTIONS = [
  {
    title: 'Portfolios',
    value: false,
    name: 'portfolios'
  },
  {
    title: 'Indexes',
    value: false,
    name: 'indexes'
  },
  {
    title: 'Proposed Managers',
    value: false,
    name: 'showProposedManagers'
  }
];

export const DISPLAY_OPTIONS = [
  {
    label: 'Heat Map',
    value: 'heatmap'
  },
  {
    label: 'Tree Map',
    value: 'treemap'
  },
  {
    label: 'Distribution',
    value: 'distribution'
  }
];

export const ADMIN_RADIO_OPTIONS = [
  {
    title: 'Portfolios',
    value: false,
    name: 'showPortfolios'
  },
  {
    title: 'Indexes',
    value: false,
    name: 'showIndexes'
  },
  {
    title: 'Proposed Managers',
    value: false,
    name: 'showProposedManagers'
  }
];

export const defaultCheckboxState = {
  portfolios: false,
  indexes: false,
  showProposedManagers: false
};
